import React, {Component} from 'react'
import Base from '../BaseComponent'

import { TweenMax,Expo } from "gsap";
import Hammer from 'react-hammerjs'

class TouchScroller extends Component {

    touchTimer = 0

  constructor(props)
  {
    super(props)
    this.state = {
        width: '100%',
        left: '0px',
        height: '180px',
        x: 0,
        activeEntry: null,
        activeIndex: 0,
        mounted: false,
        lastUpdate:new Date().getTime()
    }
  }



  componentDidMount()
  {

    let isTouch = "ontouchstart" in document.documentElement ? true : false


    if(isTouch) {
        let el = this.refs.scroller;

        /*el.addEventListener("touchstart", this.touchStart, false);
        el.addEventListener("touchmove", this.touchMove, false);
        el.addEventListener("touchend", this.touchEnd, false);*/
    
        if(this.props.onInit) this.props.onInit(this);

        this.setState({mounted: true})

    this.snap()
    }

    

    
  }

  render () {


    return (
            <div className={'TouchScroller TouchScroller--' + this.props.modifier} ref="parent">
                <Hammer onPan={this.handlePan} onPanEnd={this.panEnd}>
                <div ref="scroller" style={{transform:'translate3d('+this.state.x+'px,0px,0px)',height:this.state.height}}>
                    { this.props.children }
                </div>
                </Hammer>
            </div>
    )
  }

  handlePan = (evt) => {
    let newX = this.state.lastX + evt.deltaX
    if(newX > 0) newX = 0
    if(Math.abs(newX) > this.length) newX = -this.length
    this.setState({x:newX})
  }

  panEnd = (evt) => {
    let direction = this.state.x < this.state.lastX ? 1 : -1
    this.setState({lastX:this.state.x})
    this.snap(direction)
    //console.log('end',direction)
  }

  update = () => {

    /*if(this.state.x < (-this.length)) this.state.x = -this.length
    if(this.state.x > 0) this.state.x = 0*/
    //this.setState({left: this.state.x + 'px'})
  }

  snapTo = (el) => {

  }

  snap = (direction = 0) => {
    let _this = this
    let distances = [] // stores each items distance fro the left of the screen
    let actualDistances = []
    let snapTo = this.items[0];
    let newIndex = 0;
    let curX = this.state.x

    let active = null
    let foundNext = false

    let align = this.props.align

    //console.log('snap direction',direction)

    if(direction == 0) // on init only, get the first
    {
      snapTo = this.items[0]
    } else {
      for (var i = 0; i < this.items.length; i++) {

        // check for active class
        if(this.items[i].classList.contains('is-active'))
        {

          active = this.items[i]
            newIndex = direction > 0 ? i+1 : i-1
            if(newIndex >= this.items.length) newIndex = i
            snapTo = this.items[newIndex]
            

        }

      }
    }
    /*let min = Math.min(...distances);
    let closestLinkIndex = distances.indexOf(min);*/

    //console.log(snapTo)

    //if(direction != 0 && !foundNext) snapTo = active

    if(curX > 0) curX = 0

    let targ = this.getOffset(snapTo);
    let targP = align == 'center' ? targ.left + (targ.width/2) : targ.left
    let targPos = (targP + Math.abs(curX)  - 5) - this.props.offset

    const anim = { val: curX };

    
    TweenMax.to(anim,0.3,{val:-targPos,ease:Expo.easeOut,onUpdate: function()
    {
        //_this.state.x = anim.val
        _this.setState({x:anim.val})

        ///console.log(anim.val)
        //_this.update()
    },onComplete: function()
        {
            _this.setActiveItem(newIndex)

            //_this.lastX = _this.state.x
            _this.setState({lastX:anim.val})

            if(_this.props.itemSnap && typeof snapTo == 'object') _this.props.itemSnap(snapTo)
        }})


  }

  scrollTo = (el) => {
      let _this = this
      let targ = this.getOffset(el);
      let targP = this.props.align == 'center' ? targ.left + (targ.width/2) : targ.left
      let targPos = (targP + Math.abs(this.state.x)  - 5) - this.props.offset

      const anim = { val: this.state.x };

      let newIndex = this.getIndex(el)

    
      TweenMax.to(anim,0.3,{val:-targPos,ease:Expo.easeOut,onUpdate: function()
      {
          _this.state.x = anim.val
          _this.setState({x:anim.val})


          ///console.log(anim.val)
          _this.update()
      },onComplete: function()
        {
            _this.setActiveItem(newIndex)

            //_this.lastX = _this.state.x
            _this.setState({lastX:anim.val})
        }})

  }

  resetX = () => {
    this.setState({x:0})
    this.setState({lastX:0})

    for(var i = 0 ; i < this.items.length; i++)
    {
      this.items[i].classList.remove('is-active');
    }

    this.items[0].classList.add('is-active');
  }

  getIndex = (el) => {
    for (var i = 0; i < this.items.length; i++) {
        if(this.items[i] == el) return i
    }
  }

  setActiveItem = (index) => {
    for (var i=0; i< this.items.length; i++)
    {
      if(index == i) this.items[i].classList.add("is-active");
      else this.items[i].classList.remove("is-active");
    }
  }

  getOffset = el => {
    if(!el) return { top: 0, left: 0, width: 0 }
    let rect = el.getBoundingClientRect();
    return { top: rect.top, left: rect.left, width: rect.width };
  };

  setupScroll = (items,length,height,doSnap = false) => {
    console.log('setupScroll')
    this.items = items
    this.length = length
    this.setState({width: length + 'px',height: height + 'px'})

    if (doSnap) this.snap()

  }

  /*touchStart = (e) => {
    let d = new Date();
    this.touchTime = d.getTime();
    this.touchStart = e.touches[0].pageX;
    this.touchPos = e.touches[0].pageX;
    this.moved = 0;
    this.totalMoved = 0;
  };

  touchMove = (e) => {
    this.moved = this.touchPos - e.touches[0].pageX;
    let sx = this.state.x - this.moved

    if(sx > 0) sx = 0

    this.setState({x:sx})
    e.preventDefault();

    this.touchPos = e.touches[0].pageX;

  }

  touchEnd = (e) => {

    this.totalMoved = this.touchPos - this.touchStart;
    ///console.log(this.moved,this.totalMoved)
    if(Math.abs(this.totalMoved) < 5) return

    let lastX = this.state.lastX
    if(lastX > 0) lastX = 0

    let newX = this.state.x
    if(newX > 0) newX = 0

    let snapDirection = Math.abs(lastX) > Math.abs(newX) ? -1 : 1

    if(lastX == 0 && newX == 0) {
      snapDirection = 0
    }
    

    let _this = this
    setTimeout(function()
    {
        _this.snap(snapDirection)
    },50)
    
  }*/




}

export default TouchScroller



// WEBPACK FOOTER //
// ./src/js/components/TouchScroller/TouchScroller.jsx